import {forwardRef, useCallback, useState} from 'react';
import {Button} from '~library/atoms/Button';
import {Input} from '~library/atoms/Input';
import {Typography} from '~library/atoms/Typography';
import {EditLineIcon} from '~library/svg/EditLineIcon';
import {tanzanite} from '~libSass/base/_exports.sass';
import './MessageInput.sass';

const MessageDisplay = ({message, onClick}) => (
  <div className="message-display">
    <Typography variant="paragraph2" data-qa-id="message-display" className="message-display__text">
      {message}
    </Typography>
    <Button
      type="button"
      variant="transparent"
      onClick={onClick}
      className="message-input__actions__button"
      data-qa-id="message-display"
    >
      <EditLineIcon ratio={0.5} color={tanzanite} />
      Edit
    </Button>
  </div>
);

export const MessageInput = forwardRef(
  (
    {message, onMessageChange, onDoneClick, dataQaId, initialState = true, maxLength = 200},
    ref
  ) => {
    const [isEditing, setEditing] = useState(initialState);

    const onDoneClickHandler = useCallback(
      (e) => {
        e.preventDefault();
        setEditing(false);
        onDoneClick();
      },
      [onDoneClick]
    );

    const onMessageChangeHandler = useCallback(
      (typedMessage) => {
        const count = typedMessage?.replace(/(\r\n|\n|\r)/g, ' ')?.length;
        if (count <= maxLength) {
          onMessageChange(typedMessage);
        } else {
          const finalString = count - maxLength;
          onMessageChange(typedMessage.slice(0, -finalString));
        }
      },
      [onMessageChange, maxLength]
    );

    return isEditing || !message ? (
      <form className="message-input" onSubmit={onDoneClickHandler}>
        <Input
          ref={ref}
          data-qa-id={dataQaId}
          type="textarea"
          value={message}
          onChange={(e) => onMessageChangeHandler(e.target.value)}
          className="message-input__input"
          rows={5}
          required
          placeholder="Add your message here"
        />
        <div className="message-input__actions">
          <Typography variant="paragraph2" className="message-input__actions__text-length">
            {message?.replace(/(\r\n|\n|\r)/g, ' ').length}/{maxLength}
          </Typography>
          {!!message?.length && (
            <Button
              variant="transparent"
              formSubmit
              className="message-input__actions__button"
              data-qa-id="message-input-done-btn"
              type="submit"
            >
              Done
            </Button>
          )}
        </div>
      </form>
    ) : (
      <MessageDisplay message={message} onClick={() => setEditing(true)} />
    );
  }
);
